import { registerEnumType } from 'type-graphql'

export enum PaymentGatewayProviderEnum {
  stripe = 'stripe',
  paymongo = 'paymongo',
}

registerEnumType(PaymentGatewayProviderEnum, {
  name: 'PaymentGatewayProviderEnum',
  description: 'Which payment gateway processes a checkout — selects the IPaymentGateway implementation.',
})

export type PaymentGatewayProvider = PaymentGatewayProviderEnum | null | undefined
